import { apiAxiosV1 } from '@/configs/axios';
import { v4 as uuid } from 'uuid';
export const UploadService = {
  async uploadImage(file) {
    const formData = new FormData();
    formData.append('destination', uuid());
    formData.append('data', file);
    const res = await apiAxiosV1.post('/upload/image', formData);

    return res.data;
  },
  async uploadRaw(file) {
    const formData = new FormData();
    formData.append('destination', uuid());
    formData.append('data', file);
    const res = await apiAxiosV1.post('/upload/raw', formData);

    return res.data;
  }
};
